import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vuetify/dist/vuetify.min.css';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueGoodTablePlugin from 'vue-good-table';
// import the styles
import 'vue-good-table/dist/vue-good-table.css';
import Vuetify from 'vuetify';
import VueQRCodeComponent from 'vue-qr-generator';
import '~/plugins';
import '~/components';
import Vuelidate from 'vuelidate';
import VueSidebarMenu from 'vue-sidebar-menu';
import vuetify from './plugins/vuetify';
import i18n from '~/plugins/i18n';
import store from '~/store';
import App from '~/components/App';
import router from '~/router';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';
import RolesPermissions from './mixin/RolesPermissions';

Vue.use(VueSidebarMenu);

Vue.use(Vuelidate);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(Vuetify);
Vue.component('qr-code', VueQRCodeComponent);
Vue.mixin(RolesPermissions);
Vue.use(VueGoodTablePlugin);

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  router,
  vuetify,
  ...App,
}).$mount('#app');

Vue.component('fa', FontAwesomeIcon);
